import axios from "axios";

export const _axios = axios.create();

_axios.interceptors.request.use(
  (config) => {
    config.baseURL = "https://mouhannadabdalrhem.online/api/v1";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
